import React, { useState } from 'react'
import BEMHelper from '@ynap/bem-helper'
import { Button } from '@ynap/button'
import Notification from '@ynap/notification'
import { clickToAddGiftCard } from '../analytics'
import track from 'react-tracking'
import { GiftCardOptionProps } from './types'

const bem = new BEMHelper('GiftCardOption')

const GiftCardOption = ({ messages }: GiftCardOptionProps) => {
    const [giftCardToastShown, setGiftCardToastShown] = useState(false)

    const openGiftCardToast = () => {
        track(clickToAddGiftCard)
    }

    const toggleGiftCardToast = () => {
        giftCardToastShown ? null : openGiftCardToast()
        setGiftCardToastShown((prev) => !prev)
    }

    const renderGiftCardToast = () => {
        if (!giftCardToastShown) return null

        const contactNumber = window?.SF?.getContactDetails()?.customerCare?.telephone || messages.paymentCodes.fallbackCustomerCarePhoneNumber()
        const message = (
            <p className={bem('gift-card-toast-message')}>{messages.paymentCodes.addGiftCardInstructions({ styledCustomerCarePhoneNumber: contactNumber })}</p>
        )
        return <Notification className={bem('gift-card-toast')} type="info" message={message} arrow="top" arrowClassName={bem('gift-card-toast-arrow')} />
    }

    return (
        <>
            <Button component="a" className={bem('inline-link', 'add-gift-card')} onClick={toggleGiftCardToast}>
                {messages.paymentCodes.addGiftCard()}
            </Button>
            {renderGiftCardToast()}
        </>
    )
}

export default track({
    page: 'Payment Step',
})(GiftCardOption)
